import { render, staticRenderFns } from "./loading-components.vue?vue&type=template&id=1cf253e9"
import script from "./loading-components.vue?vue&type=script&lang=js"
export * from "./loading-components.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports